<script lang="ts">
  import { run } from "svelte/legacy";

  interface Props {
    iconSize: number;
    show?: boolean;
    class?: string;
    children?: import("svelte").Snippet;
  }

  let { iconSize, show = $bindable(false), class: className, children }: Props = $props();
  let btn = $state();
  let wrapper = $state();

  const toggleButton = (event) => {
    show = !show;
    if (show) {
    }
  };
  const onMouseClick = (event) => {
    if (show && !btn.contains(event.target)) {
      show = !show;
    }
  };

  let offset = $state();
  $effect(() => {
    if (show && wrapper) {
      const elDistanceToTop = window.pageYOffset + btn.getBoundingClientRect().top;
      // if the distance to top is smaller then the wrapper put the popup under instead
      if (wrapper.offsetHeight + 20 > elDistanceToTop) {
        offset = 0;
      } else {
        offset = wrapper.offsetHeight + 20;
      }
    }
  });
</script>

<button
  type="button"
  class="relative information-button"
  onclick={(event) => toggleButton(event)}
  bind:this={btn}
>
  <div class={className}>
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
        stroke="currentcolor"
        stroke-width="2"
      />
      <path d="M10.5 6H11" stroke="currentcolor" stroke-width="2" stroke-linecap="round" />
      <path
        d="M9 10H11V15"
        stroke="currentcolor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 15H13"
        stroke="currentcolor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>

  {#if show}
    <div
      bind:this={wrapper}
      class="fade-in information-description -left-52 sm:-left-2 rounded-sm shadow-md absolute top-0 w-60 md:w-80 text-sm md:text-base text-left text-Neutral110 p-2 bg-PurplePrimary"
      style={wrapper && offset !== 0 ? `top: -${offset}px` : ""}
      class:reversed={offset == 0}
    >
      {@render children?.()}
    </div>
  {/if}
</button>
<svelte:body onmousedown={onMouseClick} />
